import HeaderLogoImage from "TEACHER_ASSETS/images/header/logo.png";
import ComponentLoaderGif from "TEACHER_ASSETS/images/common/loader.gif";
import Child1Image from "TEACHER_ASSETS/images/avatars/child-1-thumb.png";
import Child2Image from "TEACHER_ASSETS/images/avatars/child-2-thumb.png";
import Child3Image from "TEACHER_ASSETS/images/avatars/child-3-thumb.png";
import Child4Image from "TEACHER_ASSETS/images/avatars/child-4-thumb.png";
import Child5Image from "TEACHER_ASSETS/images/avatars/child-5-thumb.png";
import Child6Image from "TEACHER_ASSETS/images/avatars/child-6-thumb.png";
import Child1Avatar from "TEACHER_ASSETS/images/avatars/child-1.png";
import Child2Avatar from "TEACHER_ASSETS/images/avatars/child-2.png";
import Child3Avatar from "TEACHER_ASSETS/images/avatars/child-3.png";
import Child4Avatar from "TEACHER_ASSETS/images/avatars/child-4.png";
import Child5Avatar from "TEACHER_ASSETS/images/avatars/child-5.png";
import Child6Avatar from "TEACHER_ASSETS/images/avatars/child-6.png";

export const ImageUtility = {
    splashLearnLogo: HeaderLogoImage,
    loaderGif: ComponentLoaderGif,
    avatars: {
        "avatars/child-1-thumb.png": Child1Image,
        "avatars/child-2-thumb.png": Child2Image,
        "avatars/child-3-thumb.png": Child3Image,
        "avatars/child-4-thumb.png": Child4Image,
        "avatars/child-5-thumb.png": Child5Image,
        "avatars/child-6-thumb.png": Child6Image,
        "avatars/child-1.png": Child1Avatar,
        "avatars/child-2.png": Child2Avatar,
        "avatars/child-3.png": Child3Avatar,
        "avatars/child-4.png": Child4Avatar,
        "avatars/child-5.png": Child5Avatar,
        "avatars/child-6.png": Child6Avatar,
    }
};